import { render, staticRenderFns } from "./message-content.vue?vue&type=template&id=11758faa&scoped=true"
import script from "./message-content.vue?vue&type=script&lang=js"
export * from "./message-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11758faa",
  null
  
)

export default component.exports